import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, TextField } from '@mui/material';
import { useIcxAuthenticateLazyQuery } from '@generated/graphql';
import { getStorageItem, setStorageItem, STORAGE_ACTION } from '@utils/storage';
import useGoPathAfterRender from '@hooks/useGoPathAfterRender';

const Login = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState({
    error: false,
    message: ''
  });
  const isPasswordNull = !password.length;

  const [fetchIcxAuthenticate] = useIcxAuthenticateLazyQuery();

  useGoPathAfterRender(
    '/industry?page=1',
    !!getStorageItem(STORAGE_ACTION.ACCESS_TOKEN)
  );

  const handleSubmit = (e: any) => {
    e.preventDefault();
    fetchIcxAuthenticate({
      variables: {
        input: {
          password: password
        }
      },
      onError: () => {
        setError({
          error: true,
          message: '서버와 연결이 불안정합니다.'
        });
      },
      onCompleted: (data) => {
        if (!data.icxAuthenticate.data) {
          setError({
            error: true,
            message: '비밀번호가 틀렸습니다.'
          });
          return;
        }
        setStorageItem(
          STORAGE_ACTION.ACCESS_TOKEN,
          data.icxAuthenticate.data.accessToken
        );
        setStorageItem(
          STORAGE_ACTION.REFRESH_TOKEN,
          data.icxAuthenticate.data.refreshToken
        );
        navigate('/industry?page=1');
      }
    });
  };

  return (
    <Grid
      component={'form'}
      container
      direction={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      gap={2}
      height={'100vh'}
      onSubmit={handleSubmit}
    >
      <Grid item width={390}>
        <TextField
          autoComplete={'off'}
          type={'password'}
          size={'medium'}
          label="비밀번호"
          placeholder="비밀번호를 입력하세요"
          sx={{ width: 390 }}
          error={error.error}
          helperText={error.message.length ? error.message : ''}
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setError({
              error: false,
              message: ''
            });
          }}
        />
      </Grid>
      <Grid item width={390}>
        <Button
          type={'submit'}
          variant={'contained'}
          size={'large'}
          fullWidth
          disabled={isPasswordNull}
          sx={{ height: 56 }}
        >
          확인
        </Button>
      </Grid>
    </Grid>
  );
};

export default Login;
